import SEOMeta from '@/components/base/SEOMeta';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryPreview from './components/CategoryPreview';
import PopularSection from './components/PopularSection';
import LatestSection from './components/LatestSection';
import StatsBanner from './components/StatsBanner';
import { siteInfo } from '@/mocks/comics';

export default function Home() {
  const webSiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteInfo.name,
    url: siteInfo.url,
    description: siteInfo.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${siteInfo.url}/search?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: siteInfo.url,
    description: siteInfo.description,
    contactPoint: {
      '@type': 'ContactPoint',
      email: siteInfo.email,
      contactType: 'customer service',
    },
  };

  return (
    <>
      <SEOMeta
        title="好看的韩国漫画_韩漫在线免费阅读"
        description={siteInfo.description}
        keywords="尾巴漫画网,好看的韩国漫画,韩漫在线免费阅读,韩漫,免费漫画,韩国漫画在线阅读"
        canonicalUrl={siteInfo.url}
        ogType="website"
        schema={[webSiteSchema, orgSchema]}
      />
      <ScrollToTop />
      <Navbar />

      <main>
        <HeroSection />
        <StatsBanner />
        <CategoryPreview />
        <PopularSection />
        <LatestSection />
      </main>

      <Footer />
    </>
  );
}